declare const brand: unique symbol;
type Brand<T, B extends string> = T & { readonly [brand]: B };

export type LeafKey = Brand<string, 'LeafKey'>;
export type PlantId = Brand<string, 'PlantId'>;
export type ClusterId = Brand<string, 'ClusterId'>;
export type ModuleKey = Brand<string, 'ModuleKey'>;
export type RoleKey = Brand<string, 'RoleKey'>;

export const asLeafKey = (s: string): LeafKey => s as LeafKey;
export const asPlantId = (s: string): PlantId => s as PlantId;
export const asClusterId = (s: string): ClusterId => s as ClusterId;
export const asModuleKey = (s: string): ModuleKey => s as ModuleKey;
export const asRoleKey = (s: string): RoleKey => s as RoleKey;

export const ADMIN_GRANTS = ['PEOPLE', 'TECHNICAL', 'FULL_SITE', 'GLOBAL'] as const;
export type AdminGrant = (typeof ADMIN_GRANTS)[number];

export const isAdminGrant = (raw: string): raw is AdminGrant => (ADMIN_GRANTS as readonly string[]).includes(raw);

export const EXCEPTION_KEYS = ['REMOTE_ACTUATION', 'VIEW_AS_USER', 'SENSOR_HEALTH'] as const;
export type ExceptionKey = (typeof EXCEPTION_KEYS)[number];

export const isExceptionKey = (key: string): key is ExceptionKey => (EXCEPTION_KEYS as readonly string[]).includes(key);

export interface MeAccess {
  readonly adminGrant: AdminGrant | null;
  readonly adminKeys: ReadonlySet<LeafKey>;
  readonly plantIds: readonly PlantId[];
}

export interface SiteAccess {
  readonly plantId: string;
  readonly canView: boolean;
  readonly canEditNotifications: boolean;
  readonly canEditPlant: boolean;
  readonly canManagePeople: boolean;
}
